import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';

function MuiDialog({ open, handleClose }) {
  return (
    <Dialog fullWidth={true} maxWidth={'sm'} open={open} onClose={handleClose}>
      <DialogTitle>Información</DialogTitle>
      <DialogContent>
        <DialogContentText>
          La descarga no fue posible. El límite máximo de orígenes permitido es
          (19), selecciona los orígenes de tu interés.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Entendido</Button>
      </DialogActions>
    </Dialog>
  );
}

MuiDialog.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
};

export default MuiDialog;
